// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import { baseIcon, defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
import { isWaffle, isWhiteLabel } from '@bubble-ui/particle-design-versions';
var IconBackNavigationPathPancake = 'M18.387 9.89a3.948 3.948 0 0 0-3.509-2.08H4.235l3.633-4.359L6.331 2.17l-5 6c-.308.371-.308.91 0 1.281l5 6 1.537-1.281-3.633-4.36h10.643c.742 0 1.398.389 1.754 1.04.357.651.331 1.413-.013 1.958l-2.972 3.776 1.572 1.238 3.029-3.856c.8-1.25.852-2.774.139-4.076Z';
var IconBackNavigationPathWaffle = 'M12.5 9.167H4.047c.418-.365.828-.74 1.222-1.129a27.562 27.562 0 0 0 2.905-3.381l-1.348-.98a25.873 25.873 0 0 1-2.728 3.176c-.91.899-1.892 1.73-2.919 2.471a.833.833 0 0 0 0 1.352 24.844 24.844 0 0 1 2.92 2.471 25.87 25.87 0 0 1 2.727 3.177l1.348-.981a27.57 27.57 0 0 0-2.905-3.381c-.394-.39-.804-.764-1.222-1.129H12.5c2.757 0 5 2.243 5 5h1.667A6.674 6.674 0 0 0 12.5 9.167Z';
var IconBackNavigationPathWaffleFilled = 'M12.5 9.167H4.047c.418-.365.828-.74 1.222-1.129a27.562 27.562 0 0 0 2.905-3.381l-1.348-.98a25.873 25.873 0 0 1-2.728 3.176c-.91.899-1.892 1.73-2.919 2.471a.833.833 0 0 0 0 1.352 24.844 24.844 0 0 1 2.92 2.471 25.87 25.87 0 0 1 2.727 3.177l1.348-.981a27.57 27.57 0 0 0-2.905-3.381c-.394-.39-.804-.764-1.222-1.129H12.5c2.757 0 5 2.243 5 5h1.667A6.674 6.674 0 0 0 12.5 9.167Z';
var IconBackNavigationPathWhiteLabel = 'm7.148 10.864 4.078 4.078L10 16.17 3.83 10 10 3.832l1.226 1.226-4.078 4.078h9.02v1.73h-9.02Z';
var IconBackNavigationPathWhiteLabelFilled = 'm7.148 10.864 4.078 4.078L10 16.17 3.83 10 10 3.832l1.226 1.226-4.078 4.078h9.02v1.73h-9.02Z';
var IconBackNavigationViewBoxWaffle = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconBackNavigationViewBoxWaffleFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconBackNavigationViewBoxWhiteLabel = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconBackNavigationViewBoxWhiteLabelFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
export var IconBackNavigation = baseIcon('IconBackNavigation', {
  groupProps: defaultIconGroupProps,
  getPath: _ref => {
    var {
      designVersion,
      filled
    } = _ref;
    return isWhiteLabel(designVersion) ? filled ? IconBackNavigationPathWhiteLabelFilled : IconBackNavigationPathWhiteLabel : isWaffle(designVersion) ? filled ? IconBackNavigationPathWaffleFilled : IconBackNavigationPathWaffle : IconBackNavigationPathPancake;
  },
  shapeSize: _ref2 => {
    var {
      designVersion,
      filled
    } = _ref2;
    return isWhiteLabel(designVersion) ? filled ? IconBackNavigationViewBoxWhiteLabelFilled : IconBackNavigationViewBoxWhiteLabel : isWaffle(designVersion) ? filled ? IconBackNavigationViewBoxWaffleFilled : IconBackNavigationViewBoxWaffle : {};
  }
});
//# sourceMappingURL=index.js.map